<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html,
body,
.v-application {
  background-color: #f8fafc !important;
  overflow-x: hidden;
  -webkit-tap-highlight-color: transparent;
}

/* 现代移动端悬浮胶囊 Toast */
.floating-toast .v-snackbar__wrapper {
  margin-bottom: calc(64px + env(safe-area-inset-bottom, 0px)) !important;
  max-width: calc(100vw - 32px) !important;
  min-height: 44px !important;
  padding: 2px 8px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18) !important;
}

.floating-toast .v-snackbar__content {
  padding: 8px 12px !important;
}

.floating-toast .v-snackbar__actions {
  margin-right: 4px !important;
}
</style>
